import {
  Button,
  DatePicker,
  Modal,
  Pagination,
  Select,
  Upload,
  message,
} from "antd";
import moment from "moment";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { Products, get_prod_filters, get_products } from "../actions/orders";
import fuel from "../assets/fuel.png";
import Menu from "../assets/menu.svg";
import no_sound from "../assets/no_sound.png";
import rain from "../assets/rain.png";
import refresh from "../assets/refresh.svg";
import Search from "../assets/search.svg";
// import snow from "../assets/snow.png";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as yup from "yup";
import { season_icons } from "../../components/ShopForTyres";
import peak from "../assets/peak.png";
import sound from "../assets/sound.png";
import Tyre from "../assets/coming-soon.jpg";
import Table from "../common/Table";
import { apis } from "../config/apis";
import endpoint from "../config/endpoint";
import SelectComponent from "../form-components/Select";
import NavBar from "./NavBar";

export const NavWrap = (props) => {
  return (
    <div>
      {!props.noNav && (
        <>
          <NavBar setCartPopup={props.setCartPopup} />
          <br />
          <br />
          <br />
          <br />
        </>
      )}
      {props.children}
    </div>
  );
};

export const TableWrap = (props) => {
  const [activePage, setActivePage] = useState(1);
  const [filterIdx, setFilterIdx] = useState(0);
  const [searchVal, setSearchVal] = useState("");
  const history = useHistory();
  const location = useLocation();
  const timeOutRef = useRef();
  const { p_filters, setFilters } = props;
  const handleCreatePaginator = useCallback((total, range) => {
    return `Showing ${range[0]} to ${range[1]} of ${total} entires`;
  }, []);

  useEffect(() => {
    if (!props.searchVal) setSearchVal("");
  }, [props.searchVal]);

  useEffect(() => {
    if (location?.state?.filters) {
      setFilters(location?.state?.filters);
    }
    // eslint-disable-next-line
  }, []);
  return (
    <div className="showTyresFilters">
      <div className="flex-between head">
        <h3>
          {props.name}

          {props.namedFilters && props.namedFilters.length > 0 && (
            <span className="named-filters">
              {props.namedFilters.map((ele, i) => {
                return (
                  <span
                    className={
                      i === filterIdx || ele.isActive
                        ? "active cursor"
                        : "cursor"
                    }
                    onClick={() => {
                      ele.action();
                      setFilterIdx(i);
                    }}
                  >
                    {i === 0 ? <span className="mlHalf mrHalf">-</span> : ""}
                    {ele.label}
                  </span>
                );
              })}
            </span>
          )}
        </h3>
        <div className="d-flex">
          {props.isDateFilter && (
            <div className="filters flex-between ml2 mr2">
              {props.isRange ? (
                <DatePicker.RangePicker
                  format={"DD-MM-YYYY"}
                  value={
                    props.dates?.start_date && props.dates?.end_date
                      ? [props.dates?.start_date, props.dates?.end_date]
                      : []
                  }
                  onChange={(vals) => {
                    props.onRangeChange(vals);
                    setActivePage(1);
                  }}
                  placeholder={props.rangePlaceholder}
                  disabledDate={(current) => {
                    // Can not select days before today and today
                    return current && current > moment().endOf("day");
                  }}
                />
              ) : (
                <DatePicker />
              )}
            </div>
          )}
          {props.createBtn && (
            <button
              className="primary-btn mr1 createBtn"
              onClick={() => {
                history.push("/admin" + props.to);
              }}
            >
              Create {props.createText}
            </button>
          )}
          {props.selectBox && (
            <div className="mr2">
              <SelectComponent
                options={props.options}
                placeholder={props.selectPlaceHolder}
                value={props.value}
                onChange={props.onSelect}
                onClear={props.onClear}
                mode={props.mode}
              />
            </div>
          )}
          {!props.isSearch && (
            <div className="input">
              <img src={Search} alt="search" />
              <input
                placeholder={props.searchPlaceholder}
                onChange={(e) => {
                  if (timeOutRef?.current) {
                    clearTimeout(timeOutRef?.current);
                  }
                  setSearchVal(e.target.value?.trimStart());
                  timeOutRef.current = setTimeout(() => {
                    if (props.callSearch) {
                      setActivePage(1);
                      props.callSearch(e.target.value?.trimStart());
                    }
                  }, 700);
                }}
                id="search-input"
                value={searchVal}
              />
            </div>
          )}
          {props.showBulk && (
            <button onClick={props.onBluk}>Bulk Images Upload</button>
          )}
          {props.showGrid && (
            <>
              <button
                onClick={() => {
                  props.setGrid && props.setGrid((bool) => !bool);
                }}
              >
                <img src={Menu} alt="menu" />
              </button>
            </>
          )}
          {props.isSync && (
            <>
              <button
                onClick={() => {
                  props.sync && props.sync();
                }}
              >
                <span className="sync-text">Sync</span>
                <img src={refresh} alt="menu" className="sync" />
              </button>
            </>
          )}
        </div>
      </div>
      {props.isFilter && (
        <div className="filters flex-between ml2 mr2">
          {props.filters.map((ele) => (
            <SelectComponent
              mode="multiple"
              options={ele.options}
              search={true}
              label={ele.label}
              onChange={(opt) => {
                let fils = { ...p_filters };
                fils[ele.key] = opt;
                setFilters(fils);
                if (opt?.length === 0) {
                  delete fils[ele.key];
                  props.filterCallback(
                    Object.keys(fils).map((ele) => ({ [ele]: p_filters[ele] }))
                  );
                }
              }}
              onClear={() => {
                let fils = { ...p_filters };
                delete fils[ele.key];
                props.filterCallback(
                  Object.keys(fils).map((ele) => ({ [ele]: p_filters[ele] }))
                );
                setFilters(fils);
              }}
              value={p_filters[ele.key]}
            />
          ))}
          <div>
            <button
              className="primary-btn"
              onClick={() => {
                props.filterCallback(
                  Object.keys(p_filters).map((ele) => ({
                    [ele]: p_filters[ele],
                  }))
                );
              }}
            >
              Apply Filter
            </button>
          </div>
        </div>
      )}
      {props.children}
      {props.onPageChange && (
        <div
          className={`pagination pb2 ${props.extraBottom ? "extraBottom" : ""}`}
        >
          {props.total_count ? (
            <Pagination
              total={props.total_count}
              current={activePage}
              pageSize={100}
              onChange={(page) => {
                setActivePage(page);
                props.onPageChange(page);
              }}
              showSizeChanger={false}
              showTotal={handleCreatePaginator}
            />
          ) : (
            <span>Showing - of - entries</span>
          )}
        </div>
      )}
    </div>
  );
};

const ShopForTyres = (props) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const prodsData = useSelector((state) => state?.orders?.products);
  const [showTable, setShowTable] = useState(true);
  const [uploadModal, setUploadModal] = useState(false);
  const [size, setSize] = useState(0);
  const [_progressEvt, setProgressEvt] = useState(0);
  const [searchVal, setSearchVal] = useState("");
  const [uploading, setUploading] = useState(false);
  const [p_filters, setFilters] = useState({});
  const formik = useFormik({
    initialValues: {
      pattern: undefined,
      file: null,
    },
    validationSchema: yup.object().shape({
      pattern: yup.string().required("Pattern is required."),
      file: yup.mixed().required("Attachment is required."),
    }),
    onSubmit: (vals) => {
      let formData = new FormData();
      vals.file?.forEach((ele) => {
        formData.append("files[]", ele.originFileObj);
      });
      setUploading(true);
      let params = {
        email: localStorage.getItem("email"),
      };
      formData.append("pattern", vals.pattern);
      endpoint
        .post(apis.admin.bulk_prod_upload, formData, {
          params,
          onUploadProgress: (progressEvent) => setProgressEvt(progressEvent),
        })
        .then(() => {
          setUploading(false);
          setUploadModal(false);
          formik.resetForm();
          toast.success("Files uploaded successfully.");
          let obj = {
            email: localStorage.getItem("email"),
            limit: 100,
          };
          dispatch({ type: Products.RESET });
          dispatch(get_products({ ...obj }));
        })
        .catch(() => {
          setUploading(false);
        });
    },
  });
  // const [imgIndex, setImgIndex] = useState({});
  // const imgIndexRef = useRef();
  const [quantityObj, setQuantityObj] = useState({});
  const product_filters = useSelector(
    (state) => state?.orders?.product_filters?.data
  );

  useEffect(() => {
    let obj = {
      email: localStorage.getItem("email"),
    };
    dispatch(get_prod_filters(obj));
    if (!prodsData?.data?.products?.length) {
      let filterObj = {};
      if (
        location?.state?.filters &&
        Object.keys(location?.state?.filters).length
      )
        filterObj = {
          ...location?.state?.filters,
        };

      dispatch(
        get_products({
          ...obj,
          ...filterObj,
          limit: 100,
        })
      );
    }

    return () => {
      dispatch({ type: Products.RESET });
    };
    // eslint-disable-next-line
  }, []);

  const columns = useMemo(() => {
    let obj = [
      {
        header: "IP Code",
        accessor: "sku",
        width: 9,
      },
      {
        header: "EAN",
        accessor: "ean",
        width: 8,
      },
      {
        header: "Rim",
        accessor: "rim",
        width: 4,
      },
      {
        header: "Size",
        accessor: "size",
        width: 8,
      },
      {
        header: "LI",
        accessor: "li",
        width: 5,
      },
      {
        header: "SR",
        accessor: "sr",
        width: 3,
      },
      {
        header: "LR",
        accessor: "lr",
        width: 3,
      },
      {
        header: "Mark",
        accessor: "mark",
        width: 4,
      },
      {
        header: "SW",
        accessor: "sidewall",
        width: 3,
      },
      {
        header: "Brand",
        accessor: "brand",
        width: 8,
      },
      {
        header: "Pattern",
        accessor: "pattern",
        width: 8,
      },
      {
        header: "Category",
        accessor: "season",
        width: 5,
        cell: (row) => (
          <img
            src={season_icons[row?.season?.trim()?.toLowerCase()]}
            alt="season"
            className="season"
          />
        ),
      },
      {
        header: "Application",
        accessor: "application",
        width: 8,
      },

      {
        header: <img src={fuel} width={14} height={14} alt="season" />,
        accessor: "fe",
        width: 4,
      },
      {
        header: <img src={rain} width={14} height={14} alt="season" />,
        accessor: "wg",
        width: 4,
      },
      {
        header: <img src={no_sound} width={16} height={14} alt="season" />,
        accessor: "ernc",
        width: 5,
      },
      {
        header: <img src={sound} width={16} height={14} alt="season" />,
        accessor: "ern",
        width: 4,
      },
      {
        header: <img src={peak} width={22} height={18} alt="season" />,
        accessor: "wr",
        width: 4,
      },
    ];

    return obj;
    // eslint-disable-next-line
  }, [prodsData]);

  const filters = useMemo(
    () => [
      {
        label: "Brand",
        options: product_filters?.brand
          ? product_filters?.brand
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "brand",
      },
      {
        label: "Pattern",
        options: product_filters?.pattern
          ? product_filters?.pattern?.sort()?.map((ele) => ({
              label: ele,
              value: ele,
            }))
          : [],
        key: "pattern",
      },
      {
        label: "Size",
        options: product_filters?.size
          ? product_filters?.size
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "size",
      },
      {
        label: "Rim Size",
        options: product_filters?.rim
          ? product_filters?.rim
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "rim",
      },
      {
        label: "Speed Rating",
        options: product_filters?.sr
          ? product_filters?.sr
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "sr",
      },
      {
        label: "Load Rating",
        options: product_filters?.lr
          ? product_filters?.lr
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "lr",
      },
      {
        label: "Category",
        options: product_filters?.season
          ? product_filters?.season
              ?.sort()
              ?.map((ele) => ({ label: ele, value: ele }))
          : [],
        key: "season",
      },
      {
        label: "Application",
        options: product_filters?.application
          ? product_filters?.application?.sort()?.map((ele) => ({
              label: ele,
              value: ele,
            }))
          : [],
        key: "application",
      },
    ],
    [product_filters]
  );

  const sortedFileNames = (a, b) => {
    // Extract numeric parts and convert to integers
    let numA = parseInt(a?.name?.match(/\d+/)?.[0], 10);
    let numB = parseInt(b?.name?.match(/\d+/)?.[0], 10);

    return numA - numB;
  };
  return (
    <div className="showTyresFilters admin">
      <NavWrap noNav={props.noNav}>
        <TableWrap
          filters={filters}
          p_filters={p_filters}
          setFilters={setFilters}
          isFilter={true}
          showBulk={true}
          onBluk={() => {
            setUploadModal(true);
          }}
          name={`Overview ${
            prodsData?.data?.pagination?.total_count
              ? `(${prodsData?.data?.pagination?.total_count})`
              : ""
          }`}
          showGrid={true}
          setGrid={setShowTable}
          extraBottom={Object.keys(quantityObj).length > 2}
          searchPlaceholder={"Search by IP Code"}
          total_count={prodsData?.data?.pagination?.total_count}
          perPageLimit={100}
          callSearch={(search) => {
            let obj = {
              email: localStorage.getItem("email"),
              limit: 100,
            };
            dispatch(
              get_products({
                ...obj,
                search,
              })
            );
            setSearchVal(search);
          }}
          onPageChange={(page) => {
            let obj = {
              email: localStorage.getItem("email"),
              limit: 100,
            };

            dispatch(
              get_products({
                ...obj,
                ...p_filters,
                search: searchVal,
                page: page,
              })
            );
          }}
          filterCallback={(fils) => {
            let obj = {
              email: localStorage.getItem("email"),
              limit: 100,
            };
            let filterObj = {};
            fils.forEach((ele) => {
              filterObj = {
                ...filterObj,
                ...ele,
              };
            });
            if (searchVal) {
              obj.search = searchVal;
            }
            dispatch(get_products({ ...obj, ...filterObj }));
          }}
        >
          {showTable ? (
            <Table
              columns={columns}
              data={prodsData?.data?.products ? prodsData?.data?.products : []}
              action={false}
              actionText={"Order Quantity"}
              actionWidth={7}
              quantityObj={quantityObj}
              setQuantityObj={setQuantityObj}
              onRowClick={(row) => {
                if (!props.fromOrder) {
                  history.push("/admin/product-detail", {
                    product: row,
                    filters: p_filters,
                  });
                }
              }}
              showMulti={true}
              loading={prodsData?.loading}
            />
          ) : prodsData?.loading ? (
            <div
              className="mt2 mb2"
              style={{
                height: "15rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div>
                <ScaleLoader color={"#2f2d51"} />
              </div>
            </div>
          ) : (
            <div className="d-grid pt2 pb2 orders-grid">
              {prodsData?.data &&
                prodsData?.data?.products?.length > 0 &&
                prodsData?.data?.products?.map((ele) => {
                  return (
                    <div
                      className="item"
                      onClick={() => {
                        history.push("/admin/product-detail", {
                          product: ele,
                        });
                      }}
                    >
                      <div className="flex-center mt2 mb1 img-wrap">
                        <img
                          src={
                            ele.images?.length
                              ? ele?.images?.sort(sortedFileNames)?.[0]?.url
                              : Tyre
                          }
                          width={150}
                          alt="type"
                          // onMouseEnter={() => {
                          //   if (ele.images?.length > 0) {
                          //     imgIndexRef.current = setInterval(() => {
                          //       setImgIndex(i => ({ [ele.id]: ((i || 0) + 1) % ele.images?.length }))
                          //     }, 200)
                          //   }
                          // }} onMouseLeave={() => {
                          //   if (imgIndexRef.current) {
                          //     clearInterval(imgIndexRef.current)
                          //     setImgIndex(0)
                          //   }
                          // }}
                        />
                      </div>
                      <div className="ml1 mr1 mb1">
                        <div className="flex-between light">
                          <span>{ele.size}</span>
                          <span>{ele.sku}</span>
                        </div>
                        <div className="flex-between bold">
                          <span>{ele.pattern}</span>
                          <span></span>
                        </div>
                        <div className="flex-between light o5">
                          <span>{ele.brand}</span>
                          <span>
                            {ele.li} / {ele.sr} / {ele.lr}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </TableWrap>
      </NavWrap>
      <Modal
        title="Upload Images"
        destroyOnClose={false}
        visible={uploadModal}
        maskClosable={false}
        onCancel={() => {
          if (uploading) {
            message.warn("Images are uploading for products, please wait.");
            return;
          }
          setUploadModal(false);
          setSize(0);
          formik.resetForm();
        }}
        footer={null}
      >
        <form onSubmit={formik.handleSubmit} className="marketing-form">
          <div className="mb1">
            <label>Select Pattern</label>
            <Select
              className="w100"
              showSearch
              placeHolder="Select Category"
              options={
                Array.isArray(product_filters?.pattern)
                  ? product_filters?.pattern?.map((ele) => ({
                      label: ele,
                      value: ele,
                    }))
                  : []
              }
              value={formik.values.pattern}
              onChange={(val) => {
                formik.setFieldValue("pattern", val);
              }}
            />
            {formik?.errors?.pattern && formik?.touched?.pattern && (
              <div className="error-text mtHalf">{formik?.errors?.pattern}</div>
            )}
          </div>
          <div className="mb1">
            <Upload
              beforeUpload={() => false}
              multiple
              onChange={(info) => {
                formik.setFieldValue("file", info?.fileList);
              }}
              fileList={formik.values.file}
              disabled={uploading}
            >
              <Button style={{ height: 45, width: "100%" }}>
                Browse Files
              </Button>
            </Upload>
            <span className="ml1 note">
              Note: This image will be applied to all products featuring the
              same pattern.
            </span>
            {formik?.errors?.file && formik?.touched?.file && (
              <div className="error-text mtHalf">{formik?.errors?.file}</div>
            )}
            {size > 262144000 && (
              <div className="error-text mtHalf">
                {"File should be less than 250MB"}
              </div>
            )}
          </div>
          <div>
            <button
              className="cancel-btn mr1"
              type="button"
              onClick={() => {
                if (uploading) {
                  message.warn(
                    "Images are uploading for products, please wait."
                  );
                  return;
                }
                setUploadModal(false);
                setSize(0);
                formik.resetForm();
              }}
            >
              {"Close"}
            </button>
            <button
              disabled={uploading || size > 262144000}
              className="primary-btn"
              type="submit"
            >
              {uploading ? "Uploading" : "Upload"}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default ShopForTyres;
